import React, { useState } from "react";
import BackgroundCheckModal from "../BackgroundCheckModal/BackgroundCheckModal";

const BackgroundCheckInfo = () => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">
            Background Check (will update soon)
          </p>
        </div>
        <div className="cursor-pointer">
          <img
            src="/images/editicon.svg"
            alt=""
            onClick={() => onOpenModal()}
          />
          <BackgroundCheckModal
            openModal={openModal}
            onCloseModal={onCloseModal}
          />
        </div>
      </div>
      <div className="flex justify-between employee-info-card">
        <table className="border-0">
          <tbody>
            <tr>
              <td className="title">Verification Status </td>
              <td className="data">completed </td>
            </tr>
            <tr>
              <td className="title">Assigned verificator </td>
              <td className="data">Jhon Cameron</td>
            </tr>
            <tr>
              <td className="title">Verified By</td>
              <td className="data">Jhon Cameron </td>
            </tr>
            <tr>
              <td className="title">Verified Date </td>
              <td className="data">27 Apr 2022 </td>
            </tr>
            <tr>
              <td className="title">Remarks </td>
              <td className="data">
                This employee has passed all background check verifications{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BackgroundCheckInfo;
